import { emailNotVerified, invitationPending, lockRed } from '@rootCommon/images';

const renderStatus = (status: string, verificationStatus: string, handleClickItem: () => void): JSX.Element => {
  let icon;
  if (status === 'Locked') {
    icon = lockRed;
  } else if (verificationStatus === 'Invitation Pending') {
    icon = invitationPending;
  } else if (verificationStatus === 'Verification Pending') {
    icon = emailNotVerified;
  }
  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
  return <img src={icon} alt="" onClick={handleClickItem} />;
};

export default renderStatus;
